/**
 * NOTE:
 * Dateでパース可能であり、年月日のいずれも欠損していなければtrueを返す。
 *
 * Date及びDate.parse、それらをベースにしたdayjsなどのライブラリの判定は環境によって緩かったり厳しかったりする。
 * 特にV8ではMMDD形式の日付をパースできてしまうため、それを防ぐためにこの関数を用意した。
 * CSVImportUIでしか利用しない機能のために、日付を扱うライブラリを追加するのはオーバースペックなので簡易実装をしている。
 */
export const validateDateStr = (date: string): boolean => {
  // そもそもDateのコンストラクタでパースできないものは不正
  const dateObj = new Date(date);
  if (Number.isNaN(dateObj.getTime())) {
    return false;
  }

  // 環境によってDateの判定は緩いので、YYYY-MM-DDのような形式であることを確認する
  const matches = /^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/.exec(date);
  if (!matches) {
    return false;
  }
  const year = parseInt(matches[1], 10);
  const month = parseInt(matches[2], 10);
  const day = parseInt(matches[3], 10);

  // 年月日が正常な範囲であることを確認する
  return (
    dateObj.getFullYear() === year &&
    dateObj.getMonth() + 1 === month &&
    dateObj.getDate() === day
  );
};
